import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useMutation, useQueryClient } from 'react-query';
import { franceCreate, franceUpdate } from '../../../api-services';
import swal from 'sweetalert';
import { useEffect } from 'react';

const initialState = {
  did_number: '',
  country: '',
};

const countriesList = [
  {
    label: 'France',
    value: 'FR',
  },
  // {
  //   label: 'Belgium',
  //   value: 'BE',
  // },
  // {
  //   label: 'Ukraine',
  //   value: 'UA',
  // },
];

const validationSchema = Yup.object().shape({
  did_number: Yup.number().required('Number is required'),
  country: Yup.string().required('Country is required'),
});

const AddFranceDID = ({
  setOpenModal,
  openModal,
  editData = {},
  setEditData,
}) => {
  const queryClient = useQueryClient();
  const [initialValues, setInitialValues] = useState(initialState);
  const isEdit = editData && Object.keys(editData).length > 0;

  const { mutate, isLoading } = useMutation(
    'franceMutate',
    (payload) => (isEdit ? franceUpdate(payload) : franceCreate(payload)),
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('franceList');
          handleClose();
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const handleSubmitForm = (values) => {
    if (isEdit) values.didID = editData?.didID;
    mutate({
      ...values,
      did_number: `+${values?.did_number}`,
    });
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const handleClose = () => {
    setEditData({});
    formik.resetForm();
    setOpenModal(false);
  };

  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      const { did_number, country } = editData;
      setInitialValues({ did_number: parseInt(did_number), country });
    }
  }, [editData]);

  return (
    <Modal
      size="md"
      centered
      show={openModal}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal-header ">
          <div className="icon_arrow"></div>
          <h5 className="modal-title heading heading--xs mb-0 ">
            {isEdit ? 'Update' : 'Add'} DID
          </h5>
        </div>

        <div className="modal-body">
          <div className="form-group input_control input_control--gap position-relative">
            <div className="w-100 ">
              <input
                type="number"
                step="any"
                className="form-control"
                placeholder="DID Number"
                name="did_number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.did_number}
              />
              {formik.touched.did_number && formik.errors.did_number ? (
                <div className="error_required">{formik.errors.did_number}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <select
                className="form-control"
                name="country"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values?.country}
              >
                <option value="">Please select country</option>
                {countriesList &&
                  countriesList.length > 0 &&
                  countriesList.map(({ label, value }) => (
                    <option value={value} key={value}>
                      {label}
                    </option>
                  ))}
              </select>
              {formik.touched.country && formik.errors.country ? (
                <div className="error_required">{formik.errors.country}</div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            disabled={isLoading}
            onClick={() => handleClose()}
          >
            Close
          </button>

          <button
            type="submit"
            className="btn btn-dark-blue"
            disabled={isLoading}
          >
            {isLoading ? 'Please wait...' : `${isEdit ? 'Update' : 'Add'}`}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddFranceDID;
